/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Search, X } from 'react-feather';
import { useDebounce } from '../../utils/react-hooks';
import config from '../../../config';
import { onSm } from '../../styles/responsive';
import { colors, fancyBorder } from '../../theme';
import { connectSearchBox } from 'react-instantsearch-dom';

const SearchIcon = styled(Search)`
  width: 1.2em;
  pointer-events: none;
  margin: 0px 5px 0px 11px;
`;

const CleanSearch = styled(({ ...props }) => (
  <div {...props} role="button" aria-label="clean search">
    <X />
  </div>
))`
  cursor: pointer;
  margin: 0 10px;
  svg {
    width: 1.2em;
  }
  &:hover {
    svg {
      stroke: ${(props) => props.theme.colors.primary};
    }
  }
`;

const Input = styled.input`
  outline: none;
  border: none;
  font-size: 1em;
  color: ${colors.font};
  // stroke: ${colors.font}
  transition: ${(props) => props.theme.transitions.hover};
  padding-left: 10px;
  background-color: transparent;
  width: calc(100% - 26px);
  border-width: 0 !important;
`;

const Form = styled.form`
  display: flex;
  margin-top: 12px;
  margin-bottom: 12px;
  flex-direction: row;
  align-items: center;
  ${onSm} {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  padding: 5px 2px;
  background: ${colors.background};
  stroke: ${colors.font};
  svg {
    stroke: ${colors.font};
  }
`;

const AlgoliaSearchInput = connectSearchBox(({ refine, ...rest }) => {
  // @ts-ignore
  return (
    <SearchInput
      search={(value) => {
        refine(value);
      }}
      {...rest}
    />
  );
});

const SearchInput = ({ search, inputRef, style, onFocus, onClean, ...props }) => {
  const preventSubmit = (e) => {
    e.preventDefault();
  };
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, config.features.search.debounceTime);

  useEffect(() => {
    if (search && debouncedSearchTerm && debouncedSearchTerm !== null) {
      search(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);

  const clean = (e) => {
    onClean();
    e.preventDefault();
    setSearchTerm('');
    // eslint-disable-next-line no-param-reassign
    inputRef.current.value = '';
  };

  return (
    <div
      css={{
        color: colors.font,
        position: 'sticky',
        top: '0',
        minWidth: '135px',
        background: colors.background,
        width: '100%'
      }}
    >
      <Form css={{ ...fancyBorder }} onSubmit={preventSubmit} style={style}>
        <SearchIcon />
        <Input
          onFocus={onFocus}
          ref={inputRef}
          type="text"
          placeholder={config.features.search.placeholder}
          aria-label="Search"
          onChange={(e) => {
            const { value } = e.target;
            if (value && value.length > 0) {
              setSearchTerm(value);
            }
          }}
          {...props}
        />
        <CleanSearch onClick={clean} />
      </Form>
    </div>
  );
};

export default AlgoliaSearchInput;
